import { useTranslation } from 'react-i18next'
import { CalendarDays }   from 'lucide-react'
import { PageHeader, Card } from '@/components/ui/primitives'

export default function SchedulePage() {
  const { t } = useTranslation()
  return (
    <div className="space-y-6">
      <PageHeader
        title={t('nav.schedule')}
        subtitle="Manage your exam and lesson schedule"
      />
      <Card>
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <CalendarDays size={48} className="text-blue-400 mb-4" />
          <h3 className="font-semibold text-white/72 mb-1">Schedule coming soon</h3>
          <p className="text-sm text-white/45 max-w-xs">
            A full calendar view with exam scheduling, drag-and-drop, and reminders will be available here.
          </p>
        </div>
      </Card>
    </div>
  )
}

